export default {
  '1': 'Colors',
  '2': 'Dropdowns',
  '3': 'Buttons',
  '4': 'Input',
  '5': 'Navigation',
  '6': 'Breadcrumbs',
  '7': 'Pagination',
  '8': 'Labels',
  '9': 'Badges',
  '10': 'Header',
  '11': 'Thumbnails',
  '12': 'Alerts',
  '13': 'Modals',
  '14': 'MediaObject',
  '15': 'Lists',
  '16': 'Panels'
}
